export default __webpack_public_path__ + "static/media/2023.897d9c55.png";